import styled from 'styled-components';

export const Container = styled.li<{ isSelected: boolean }>`
  position: relative;
  max-width: 48.5rem;
  min-height: 44.1rem;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 0.4rem;

  padding: 2.5rem 3.3rem;

  border: ${({ isSelected, theme }) =>
    isSelected ? `3px solid ${theme.colors.yellow}` : 'none'};

  div {
    font-size: 1.9rem;
    margin-bottom: 1.2rem;
    word-wrap: break-word;
  }

  :last-child {
    margin-bottom: 0;
  }
`;

export const Options = styled.div`
  position: absolute;
  right: 3%;
  top: 5%;

  cursor: pointer;

  > svg {
    &:hover {
      background: #dadada;
      border-radius: 50%;
    }
  }

  > div {
    display: flex;
    justify-content: center;
    flex-direction: column;

    position: absolute;
    left: -10rem;
    overflow: hidden;

    width: 14rem;

    background: #ffffff;

    box-shadow: 0px 0px 4px #40404030;
    border-radius: 2px;

    opacity: 0;

    transition: 300ms ease-in-out;
    pointer-events: none;

    .divider {
      height: 1px;
      background: #cbcbcb;
      margin: 0 0.3rem;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;

      background: #ffffff;
      height: 4rem;
      border-radius: 0;

      color: #0f0f0f;
      font-size: 1.4rem;
      font-family: ${({ theme }) => theme.fontFamily.Nunito};
      font-weight: 600;
      line-height: 1.9rem;

      :last-child {
        color: #d90606;
      }

      &:hover {
        background: #40404030;
      }
    }
  }

  &:hover {
    > div {
      opacity: 1;
      pointer-events: visible;
    }
  }
`;

export const Wrapper = styled.div`
  cursor: pointer;
`;

export const DeleteContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    margin-bottom: 3rem;
    text-transform: uppercase;
  }

  p {
    font-size: 1.8rem;
    text-align: center;
    margin-bottom: 6rem;
  }

  div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    button {
      width: 10rem;
      height: 4rem;
      background: transparent linear-gradient(96deg, #000000 0%, #232323 100%)
        0% 0% no-repeat padding-box;
      border-radius: 50px;
      opacity: 1;

      color: #fff;
      font-weight: bold;

      transition: 0.2s;

      &:hover {
        filter: brightness(0.9);
      }
    }
  }
`;

export const HeaderButtonsContainer = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;
  justify-content: center;

  width: 50%;

  button:first-child {
    width: fit-content;
    min-width: 60%;
  }
`;
